import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';

import store from 'Redux/store';
import imgixConfig from 'Config/imgix';
import { postEmail, EMAIL_SUBSCRIBE, EMAIL_ERROR } from 'Redux/ducks/email-subscribe';
import { toggleFeedbackPopup as toggleFeedbackPopupAction } from 'Redux/ducks/feedback-popups';

import 'Components/Banner/EmailSignUpMidPageBanner.scss';

const EmailSignUpMidPageBanner = ({
  auth,
  emailSubscribe,
  toggleFeedbackPopup,
  appearsOn,
}) => {
  const [email, setEmail] = useState('');

  const intl = useIntl();

  const getContext = () => {
    switch (appearsOn) {
      case 'home':
        return 'nlmodule_midhomepage';
      case 'fantasyVerse':
        return 'nlmodule_midfantasyverse';
      case 'community':
        return 'community';
      case 'bundle':
        return 'nlmodule_midbundle';
      default:
        return 'nlmodule_midhomepage';
    }
  };

  const context = getContext(appearsOn);

  const handleChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value, false);
  };

  const optinEmail = (event, emailPassed, optin) => {
    event.preventDefault();
    store.dispatch(postEmail(emailPassed, context, optin, true));
  };

  const handleSubmit = (event) => {
    if (auth.authenticated) {
      return optinEmail(event, auth.email, true);
    }
    return optinEmail(event, email, true);
  };

  // Used to trigger the feedback popups
  useEffect(() => {
    const messages = defineMessages({
      successTitle: {
        id: 'subscribe.modal.success.title',
        defaultMessage: 'Success !',
      },
      successMessage: {
        id: 'subscribe.modal.success.message',
        defaultMessage: 'You are now subscribed to the Fanatical newsletter.',
      },
      errorTitle: {
        id: 'subscribe.modal.error.title',
        defaultMessage: 'Something went wrong',
      },
      errorMessage: {
        id: 'subscribe.modal.error.message',
        defaultMessage: 'Whoops something went wrong please try again.',
      },
    });

    if (emailSubscribe.currentState === EMAIL_SUBSCRIBE && emailSubscribe.context === context) {
      toggleFeedbackPopup({ type: 'success', title: intl.formatMessage(messages.successTitle), message: intl.formatMessage(messages.successMessage) });
      localStorage.setItem('newsletterSubscribedDate ', Date.now());
    }

    if (emailSubscribe.currentState === EMAIL_ERROR && emailSubscribe.context === context) {
      toggleFeedbackPopup({ type: 'error', title: intl.formatMessage(messages.errorTitle), message: intl.formatMessage(messages.errorMessage) });
    }
  }, [emailSubscribe.currentState, emailSubscribe.context, intl, toggleFeedbackPopup, context]);

  return (
    <>
      <div id={`emailsignup-${context}`} className="EmailSignUpMidPageBanner">
        <div className="EmailSignUpMidPageBanner__left">
          <div className="EmailSignUpMidPageBanner__left__heading">
            <FormattedMessage id="home-email-banner.text-heading" defaultMessage="Sign-up for Fanatical's Newsletter!" />
          </div>
          <div className="EmailSignUpMidPageBanner__left__subtext">
            <FormattedMessage id="home-emailbanner.text-subtext" defaultMessage="Unlock special gaming deals, limited-time bundles, and more—sign up for Fanatical’s newsletter today!" />
          </div>
          <div className="EmailSignUpMidPageBanner__left__inputContainer">
            <React.Fragment>
              <form onSubmit={handleSubmit}>
                <div className="input-group">
                  <input
                    required
                    placeholder={intl.formatMessage({ id: 'home-email-banner.placeholder', defaultMessage: 'Enter your email' })}
                    className="form-control"
                    type="email"
                    name="email"
                    title="Enter your email address"
                    enterKeyHint="send"
                    aria-label="email"
                    value={auth.email}
                    onChange={handleChange}
                  />
                  <span className="input-group-append">
                    <button className="btn btn-primary pb-1 pt-0 pl-3 pr-3" type="submit">
                      <FormattedMessage
                        id="home-email-banner.modal.button"
                        defaultMessage="Subscribe"
                      />
                    </button>
                  </span>
                </div>
              </form>
            </React.Fragment>
          </div>
        </div>
        <div className="EmailSignUpMidPageBanner__right">
          <div className="EmailSignUpMidPageBanner__right__gradient" />
          <div className="EmailSignUpMidPageBanner__right__img">
            {appearsOn !== 'fantasyVerse' &&
              <img
                srcSet={`
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=1920&h=1080&fit=crop 1920w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=1280&h=720&fit=crop 1280w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=1130&h=636&fit=crop 1130w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=960&h=540&fit=crop 960w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=740&h=416&fit=crop 740w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=640&h=360&fit=crop 640w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=480&h=270&fit=crop 480w,
                https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=384&h=216&fit=crop 384w
              `}
                sizes="(min-width: 1520px) 530px, (min-width: 1200px) 450px, (min-width: 992px) 472px, (min-width: 768px) 352px, (min-width: 576px) 524px, 95vw"
                src={`https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANATICAL-May-2025.jpg?${imgixConfig}&w=1920&h=1080&fit=crop`}
                alt="Elden Ring Character"
              />
            }
            {appearsOn === 'fantasyVerse' &&
              <img
                srcSet={`
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=1920&h=1080&fit=crop 1920w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=1280&h=720&fit=crop 1280w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=1130&h=636&fit=crop 1130w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=960&h=540&fit=crop 960w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=740&h=416&fit=crop 740w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=640&h=360&fit=crop 640w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=480&h=270&fit=crop 480w,
              https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=384&h=216&fit=crop 384w
            `}
                sizes="(min-width: 1520px) 530px, (min-width: 1200px) 450px, (min-width: 992px) 472px, (min-width: 768px) 352px, (min-width: 576px) 524px, 95vw"
                src={`https://fanatical.imgix.net/production/assets/banners/email/Newsletter-Section-FANTASYVERSE.jpg?${imgixConfig}&w=1920&h=1080&fit=crop`}
                alt="The Witcher Character"
              />
            }
          </div>
        </div>
      </div>
    </>
  );
};

EmailSignUpMidPageBanner.propTypes = {
  auth: PropTypes.shape({}),
  emailSubscribe: PropTypes.shape({}),
};

EmailSignUpMidPageBanner.defaultProps = {
  auth: {},
  emailSubscribe: {},
};

const mapStateToProps = ({ auth, emailSubscribe }) => ({ auth, emailSubscribe });

const mapDispatchToProps = {
  toggleFeedbackPopup: toggleFeedbackPopupAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailSignUpMidPageBanner);
